(function () {
  'use strict';

  function money(value) {
    return 'R' + Number(value).toLocaleString('en-ZA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function getEl(root, prefix) {
    return root.querySelector('[id^="' + prefix + '"]');
  }

  function nextDefinedPacks(requiredPacks) {
    if (requiredPacks <= 1) return 1;
    if (requiredPacks <= 2) return 2;
    if (requiredPacks <= 4) return 4;
    if (requiredPacks <= 8) return 8;
    return requiredPacks;
  }

  function priceForDefinedSolutions(packs) {
    var standardTotal = packs * 315;
    return packs >= 4 ? standardTotal * 0.85 : standardTotal;
  }

  function calculate(root) {
    if (!root) return;

    var metresInput = root.querySelector('.dv-input-wrap input[type="number"]');
    var radios = root.querySelectorAll('.dv-side-options input[type="radio"]');
    var errorEl = getEl(root, 'dv-error-');
    if (!metresInput) return;

    var metres = parseFloat(metresInput.value);
    if (!isFinite(metres) || metres <= 0) {
      if (errorEl) {
        errorEl.textContent = 'Please enter a wall length greater than 0 metres.';
        errorEl.hidden = false;
      }
      metresInput.focus();
      return;
    }

    if (metres > 10000) {
      metres = 10000;
      metresInput.value = '10000';
    }

    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    var sides = 1;
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) {
        sides = parseInt(radios[i].value, 10) || 1;
        break;
      }
    }

    var requiredPlugs = Math.ceil(metres * 2 * sides);
    var requiredPacks = Math.max(1, Math.ceil(requiredPlugs / 6));
    var recommendedPacks = nextDefinedPacks(requiredPacks);
    var suppliedPlugs = recommendedPacks * 6;
    var extraPlugs = suppliedPlugs - requiredPlugs;
    var standardTotal = recommendedPacks * 315;
    var finalTotal = priceForDefinedSolutions(recommendedPacks);
    var saving = standardTotal - finalTotal;

    var plugsEl = getEl(root, 'dv-plugs-');
    var requiredPlugsEl = getEl(root, 'dv-required-plugs-');
    var metresCopy = getEl(root, 'dv-metres-copy-');
    var sideCopy = getEl(root, 'dv-side-copy-');
    var packsEl = getEl(root, 'dv-packs-');
    var suppliedEl = getEl(root, 'dv-supplied-');
    var extraEl = getEl(root, 'dv-extra-');
    var standardEl = getEl(root, 'dv-standard-');
    var savingEl = getEl(root, 'dv-saving-');
    var totalEl = getEl(root, 'dv-total-');
    var cartQty = getEl(root, 'dv-cart-qty-');
    var valueOption = getEl(root, 'dv-value-option-');
    var valueTitle = getEl(root, 'dv-value-title-');
    var valueCopy = getEl(root, 'dv-value-copy-');

    if (plugsEl) plugsEl.textContent = suppliedPlugs;
    if (requiredPlugsEl) requiredPlugsEl.textContent = requiredPlugs;
    if (metresCopy) metresCopy.textContent = (Math.round(metres * 10) / 10).toString();
    if (sideCopy) sideCopy.textContent = sides === 2 ? 'both sides' : 'one side';
    if (packsEl) packsEl.textContent = recommendedPacks;
    if (suppliedEl) suppliedEl.textContent = suppliedPlugs;
    if (extraEl) extraEl.textContent = Math.max(0, extraPlugs);
    if (standardEl) standardEl.textContent = money(standardTotal);
    if (savingEl) savingEl.textContent = money(saving);
    if (totalEl) totalEl.textContent = money(finalTotal);
    if (cartQty) cartQty.value = recommendedPacks;

    if (valueOption && valueTitle && valueCopy) {
      var minimumTotal = priceForDefinedSolutions(requiredPacks);
      var recommendationTotal = priceForDefinedSolutions(recommendedPacks);
      var difference = recommendationTotal - minimumTotal;
      var extraPacks = recommendedPacks - requiredPacks;
      var promoSaving = (recommendedPacks * 315) - recommendationTotal;

      if (requiredPacks === 3 || requiredPacks === 5 || requiredPacks === 6 || requiredPacks === 7) {
        valueOption.hidden = false;
        valueTitle.textContent = 'You need ' + requiredPacks + ' packs. The recommended ' + recommendedPacks + '-pack solution includes ' + extraPacks + ' extra pack' + (extraPacks === 1 ? '' : 's') + '.';

        if (difference > 0) {
          valueCopy.textContent =
            'Your minimum quantity costs ' + money(minimumTotal) +
            '. For ' + money(difference) + ' more, you get ' + extraPacks +
            ' extra pack' + (extraPacks === 1 ? '' : 's') +
            '. The recommended total includes a saving of ' + money(promoSaving) +
            ' off the standard ' + recommendedPacks + '-pack price.';
        } else if (difference === 0) {
          valueCopy.textContent =
            'Your minimum quantity costs ' + money(minimumTotal) +
            '. The ' + recommendedPacks + '-pack solution costs the same, so you get ' +
            extraPacks + ' extra pack' + (extraPacks === 1 ? '' : 's') +
            ' at no extra cost. The recommended total includes the 15% volume saving.';
        } else {
          valueCopy.textContent =
            'Your minimum quantity costs ' + money(minimumTotal) +
            '. The ' + recommendedPacks + '-pack solution is ' + money(Math.abs(difference)) +
            ' less and gives you ' + extraPacks +
            ' extra pack' + (extraPacks === 1 ? '' : 's') + '.';
        }
      } else {
        valueOption.hidden = true;
        valueTitle.textContent = '';
        valueCopy.textContent = '';
      }
    }

    var resultPanel = root.querySelector('.dv-result-panel');
    if (resultPanel) {
      resultPanel.setAttribute('data-calculated', 'true');
      if (window.innerWidth < 801 && typeof resultPanel.scrollIntoView === 'function') {
        resultPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('.dv-calculate-btn') : null;
    if (!button) return;
    event.preventDefault();
    calculate(button.closest('.dv-calculator-page'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target;
    if (!input || !input.matches || !input.matches('.dv-calculator-page .dv-input-wrap input[type="number"]')) return;
    event.preventDefault();
    calculate(input.closest('.dv-calculator-page'));
  });

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.matches || !radio.matches('.dv-calculator-page .dv-side-options input[type="radio"]')) return;
    var root = radio.closest('.dv-calculator-page');
    if (root && root.querySelector('.dv-result-panel[data-calculated="true"]')) {
      calculate(root);
    }
  });
})();